/* @index('./*.ts', f => `export * from '${f.path}';`) */
export * from './shorten-text.module';
export * from './shorten-text.pipe';
/* @endindex */
